<template>
    <div style="height:100%" class="d-flex flex-column">
        <h5>
            <span>このページ</span>
            <span v-if="showMode=='dst'">からの</span>
            <span v-else>への</span>
            リンク
        </h5>
        <div class="flex-grow-1 overflow-scroll">
            <div class="card p-3" v-for="anchor in showingAnchors" v-bind:key="anchor.id">
                <h4 class="card-title">
                    <i v-if="showMode=='dst'" class="bi bi-box-arrow-up-right me-2"></i>
                    <i v-else class="bi bi-box-arrow-in-down-right me-2"></i>
                    <span v-if="detailTitle">{{detailTitle}}</span>
                    <span v-else> {{anchor.name.replaceAll("|","")}}</span>
                </h4>
                <div class="card-body">
                    <p class="card-text"><span class="bi bi-file-earmark-text"></span>{{anchor.document.name}}</p>
                    <p class="card-text"><span class="bi bi-bookmark-fill"></span>{{anchor.name}}</p>
                    <p class="card-text"><span class="bi bi-chat-square-text"></span>{{anchor.snippet}}</p>
                </div>
                <div class="card-footer">
                    <div class="input-group">
                        <button class="btn btn-primary me-1" @click="showDetail(anchor.id)"><i class="bi bi-zoom-in"></i>詳細</button>
                        <a class="btn btn-primary text-white me-1" :href="anchor.url">開く</a>
                        <a class="btn btn-primary text-white" :target="anchor.document.name" :href="anchor.url">別のタブで開く</a>
                    </div>
                </div>
            </div>
            <h4 v-if="showingAnchors.length == 0">該当するリンクはありません</h4>
        </div>
        <div class="footer">
            <button id="footer-btn"
                    type="button" 
                    class="btn btn-light toggle"
                    @click="toggle" >
                {{showMode=='src' ? 'リンク一覧':'被リンク一覧' }}</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "AnchorList",
    props: {
        anchors: { type: Array, required: false },
        showMode: { type: String, required: true },
        detailTitle: { type: String, required: false, default: null}
    },
    data() {
        return {
            showingAnchors: []
        }
    },
    methods: {
        toggle() {
            this.$emit('switch-mode', (this.showMode == 'dst') ? 'src' : 'dst');
        },
        showDetail(anchorId) {
            this.$emit('src-selected', anchorId);
        },
        showPageAnchors() {
            console.log("AnchorList: showPageAnchors");
            if(this.showMode=='dst') {
                this.showingAnchors = this.anchors.filter(
                    (a) => { return a['dst_hyperlinks'].length > 0 }
                ).map( (a) => {
                    let _a = a['dst_hyperlinks'][0]['dst_anchor'];
                    a['url'] = `/?case=${a.document.lawcase.id}&obj=${encodeURI(_a.document.lawcase.path_prefix + '/' + _a.file.path)}&page=${_a.page + 1}`;
                    return a;
                });
            } else {
                this.showingAnchors = this.anchors.filter(
                    (a) => { return a['src_hyperlinks'].length > 0
                }).map( (a) => {
                    return a['src_hyperlinks'].map( l => {
                        let _a = l.src_anchor;
                        _a['url'] = `/?case=${a.document.lawcase.id}&obj=${encodeURI(_a.document.lawcase.path_prefix + '/' + _a.file.path)}&page=${_a.page + 1}`;
                        return _a;
                    })
                }).flat();
                console.log(this.showingAnchors);
            }
        }
    },
    mounted: function() {
        this.showPageAnchors()
    },
    watch: {
        anchors() {
            this.showPageAnchors();
        },
        showMode() {
            this.showPageAnchors();
        }
    }
}
</script>

<style scoped>
#footer-btn {
    width: 100%;
}

.footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1rem;
    /* background-color: #efefef; */
    text-align: center;
}

a {
    text-decoration: none;
    color: black;
}

.card  {
    margin-bottom: 1rem;
}
</style>
